<template>
  <v-card outlined class="mb-2 pa-3">
    <!-- Шапка — та же, что у карточки доски ТС: имя с кодом, номер, статус-чип справа.
         Полное название статуса не влезает, поэтому чип короткий (state_short_N), а
         полное имя живёт в native title. -->
    <div class="d-flex align-center">
      <div class="flex-grow-1" style="min-width: 0">
        <div class="text-body-2 font-weight-medium text-truncate">
          {{ car.car_name }}
          <span class="success--text">({{ car.code }})</span>
        </div>
        <div class="text-caption text--secondary">{{ car.number }}</div>
      </div>
      <v-chip x-small :color="stateColor" text-color="white" class="ml-1 flex-shrink-0" :title="stateText">
        {{ stateShort }}
      </v-chip>
    </div>

    <v-divider class="my-2" />

    <!-- Единственная крупная цифра на карточке. Страница отвечает на вопрос
         «что свободно и сколько стоит за весь период» — итог и есть ответ;
         цена за сутки и залог сравнивают варианты, поэтому они тише. -->
    <div class="d-flex align-baseline">
      <span class="text-body-2 text--secondary">{{ $t("bookings.total") }}</span>
      <span class="ml-auto text-h6 font-weight-bold">{{ car.total }} {{ currency }}</span>
    </div>
    <div class="d-flex flex-wrap text-caption text--secondary mt-1" style="gap: 0 12px">
      <span>
        {{ $t("bookings.day_price") }}:
        <span class="text--primary">{{ car.selected_price }} {{ currency }}</span>
      </span>
      <span>
        {{ $t("bookings.deposit") }}:
        <span class="text--primary">{{ car.deposit }} {{ currency }}</span>
      </span>
      <span v-if="hoursPrice > 0">
        {{ $t("bookings.hours_cost") }}:
        <span class="text--primary">{{ hoursPrice }} {{ currency }}</span>
      </span>
    </div>

    <v-divider class="my-2" />

    <!-- Состояние машины на выдачу: коробка, мойка, топливо, место хранения.
         В таблице это четыре колонки безымянных иконок — на карточке иконка
         подписана, потому что места хватает. -->
    <div class="d-flex flex-wrap align-center text-caption text--secondary" style="gap: 4px 12px">
      <!-- Те же иконки и цвета, что в таблице: источник один (carConditionMeta).
           Подпись здесь словами, а не тултипом — наведения на телефоне нет. -->
      <span v-for="item in conditions" :key="item.key">
        <v-icon x-small :color="item.color">{{ item.icon }}</v-icon>
        {{ $t(item.key) }}
      </span>
      <span v-if="showLocation && car.store_place">
        <v-icon x-small>mdi-map-marker-outline</v-icon>
        {{ car.store_place }}
      </span>
    </div>

    <!-- На десктопе бронь заводится двойным кликом по строке — на телефоне
         двойного клика нет, поэтому действие названо явно. -->
    <v-btn v-if="canBook" block small color="primary" class="mt-3" @click="$emit('book', car)">
      <v-icon left small>mdi-plus-circle</v-icon>
      {{ $t("custom.add_booking") }}
    </v-btn>
  </v-card>
</template>

<script>
import rentalObjectMixin from "@/mixins/rentalObjectMixin";
import {
  stateColorFor,
  stateKeyFor,
  transmissionMeta,
  cleanMeta,
  tankMeta,
} from "@/components/dashboard/bookings/carConditionMeta";

export default {
  mixins: [rentalObjectMixin],
  name: "SearchFreeCarCard",
  props: {
    car: { type: Object, required: true },
    currency: { type: String, default: "" },
    hoursPrice: { type: Number, default: 0 },
    showLocation: { type: Boolean, default: false },
    canBook: { type: Boolean, default: false },
  },
  computed: {
    stateColor() {
      return stateColorFor(this.car.state);
    },
    stateText() {
      const key = stateKeyFor(this.car.state);
      return key ? this.$t(key) : "—";
    },
    // Ни один из двух ярлыков не читает другой computed: цепочка computed→computed
    // не разрешается синтетическим this, на котором в проекте стоят юнит-тесты.
    stateShort() {
      const short = "cars_board.state_short_" + this.car.state;
      if (this.$te(short)) return this.$t(short);
      const full = stateKeyFor(this.car.state);
      return full ? this.$t(full) : "—";
    },
    conditions() {
      const conditions = [transmissionMeta(this.car.automatic), cleanMeta(this.car.clean_state)];
      // FT-183: индикатор топлива скрыт для типа техники компании (вело).
      if (this.hasFeature("fuel")) conditions.push(tankMeta(this.car.tank_state));
      return conditions;
    },
  },
};
</script>
